import { render, staticRenderFns } from "./SelectLandStatus.vue?vue&type=template&id=6175e9cc"
import script from "./SelectLandStatus.vue?vue&type=script&lang=js"
export * from "./SelectLandStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports